/** InsCoder WANG.J 2026-08-04 B + Virtual Appointment popup interactions **/
(function () {
  if (document.documentElement.hasAttribute('data-cust-virtual-appointment-popup-ready')) return;
  document.documentElement.setAttribute('data-cust-virtual-appointment-popup-ready', 'true');

  var triggerSelector = '[data-cust-virtual-appointment-trigger]';
  var modalSelector = '[data-cust-virtual-appointment-modal]';
  var closeSelector = '[data-cust-virtual-appointment-close]';
  var focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastFocusedElement = null;

  function getModal(trigger) {
    var modalId = trigger.getAttribute('aria-controls');
    return modalId ? document.getElementById(modalId) : document.querySelector(modalSelector);
  }

  function openModal(modal, trigger) {
    if (!modal) return;

    lastFocusedElement = trigger;
    modal.hidden = false;
    document.documentElement.classList.add('cust-virtual-appointment-popup-open');

    var closeButton = modal.querySelector('button' + closeSelector);
    if (closeButton) closeButton.focus();
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.hidden = true;
    document.documentElement.classList.remove('cust-virtual-appointment-popup-open');

    if (lastFocusedElement && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus();
    }
  }

  function keepFocusInside(event, modal) {
    var focusableElements = Array.prototype.slice.call(modal.querySelectorAll(focusableSelector));
    if (!focusableElements.length) return;

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(triggerSelector);
    if (trigger) {
      event.preventDefault();
      openModal(getModal(trigger), trigger);
      return;
    }

    var closeControl = event.target.closest(closeSelector);
    if (closeControl) {
      closeModal(closeControl.closest(modalSelector));
    }
  });

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector(modalSelector + ':not([hidden])');
    if (!modal) return;

    if (event.key === 'Escape') {
      closeModal(modal);
    } else if (event.key === 'Tab') {
      keepFocusInside(event, modal);
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('cust-virtual-appointment-popup-open');
  });
})();
/** InsCoder WANG.J 2026-08-04 E + Virtual Appointment popup interactions **/
